module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"report_button":"届出及び遮断"}}')
  delete Component.options._Ctor
}
